// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__OkXwl","tag--tiny":"Tag_tag--tiny__riYJk","tag--small":"Tag_tag--small__6gITa","tag--large":"Tag_tag--large__B+e2V","tag--secondary":"Tag_tag--secondary__mPt3f"};